<template>
  <div>
    <form id="search-form" @submit.prevent="submitQuery">
      <div>
        <textarea
          onload="this.focus()"
          type="text"
          name="q"
          class="inputarea card-animate-2"
          placeholder="Describe your query here"
          v-model="queryPrompt"
          rows="4"
          cols="500"
          @keyup.enter="submitQuery"
        ></textarea>
      </div>

      <br />
      <div>
        <v-btn class="mx-2" type="submit" value="Submit">Submit</v-btn>
        <v-btn class="mx-2" type="submit" value="Reset" @click="resetDialogue">Reset</v-btn>
        <v-btn v-if="editingQueryIndex !== -1" class="mx-2" type="submit" value="Update" @click="updateQuery">Update</v-btn>
      </div>
    </form>

    <div id="dialogueResults">
      <p v-for="(entry, index) in dialogueHistory" :key="index" v-html="entry"></p>
    </div>
    <br />
    <div v-if="loading" class="loading-container">
      <img class="mx-auto d-block" style="height: 25%; width: 25%" src="../assets/images/loading-spinner15.gif" alt="Loading" />
      <br />
      <p>{{ loadingText }}</p>
    </div>

    <div v-if="actionSteps.length">
      <p>Recommended Action Steps:</p>
      <ul>
        <li v-for="(step, index) in actionSteps" :key="index">{{ step }}</li>
      </ul>
    </div>
    <div>
      <v-btn class="mx-2" @click="saveQuery">Save Query</v-btn>
    </div>
    <br />
    <saved-query-list
      :saved-queries="savedQueries"
      @edit-query="editSavedQuery"
      @delete-query="deleteSavedQuery"
    ></saved-query-list>
  <br />
  </div>
</template>
<script>
import submitAudio from '../assets/audio/input1.wav';
import codeCompleteAudio from "../assets/audio/SelectNew.wav";
import SavedQueryList from "./SavedQueryList.vue";
export default {
  components: {
    SavedQueryList,
  },
  data() {
    return {
      lastSavedQuery: "",
      lastSavedUrl: "",
      continuousMode: false,
      loading: false,
      loadingText: "",
      queryPrompt: "",
      dialogueHistory: [],
      actionSteps: [],
      currentActionIndex: 0,
      objectivesAchieved: false,
      savedQueries: [],
      editingQueryIndex: -1,
    };
  },
  mounted() {
    const storedsavedQueries = JSON.parse(localStorage.getItem("savedQueries"));
    if (storedsavedQueries) {
      this.savedQueries = storedsavedQueries;
    }

    this.codeEditor.on("change", () => {
      const code = this.codeEditor.getValue();
      document.getElementById("outputIframe").srcdoc = code;
    });
  },
  watch: {
    dialogueHistory() {
      const code = this.dialogueHistory
        .map(entry => entry.text.replace(/<\/?[^>]+(>|$)/g, ""))
        .join("\n");
      this.codeEditor.setValue(code, 1);
      document.getElementById("outputIframe").srcdoc = code;
    },
  },
  methods: {
    async submitQuery() {
      if (!this.queryPrompt) return;

      this.dialogueHistory.push(`<strong>User:</strong> ${this.queryPrompt}`);
      new Audio(submitAudio).play();
      // Show loading spinner and "Thinking" text
      this.loading = true;
      this.loadingText = "Thinking...";

      try {
        const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ message: this.queryPrompt }),
        });
        const content = await response.json();
        new Audio(codeCompleteAudio).play();
        this.loading = false;
        this.loadingText = "Executing action to achieve objective: " + content.message;

        this.dialogueHistory.push(`<strong>AI:</strong> ${content.message}`);
        const responseUrl = content.url;

        if (responseUrl) {
          const leftOfCenter = window.innerWidth / 2 - 450;
          window.open(responseUrl, "_blank", `left=${leftOfCenter}`);
          this.lastSavedUrl = responseUrl;
        }

        this.actionSteps = content.actionSteps || []; // Example: ['Step 1', 'Step 2', 'Step 3']
        this.currentActionIndex = 0;
        this.objectivesAchieved = false;

        this.queryPrompt = "";
      } catch (err) {
        console.error(err);
      }
    },
    resetDialogue() {
    this.queryPrompt = '';
    this.dialogueHistory = [];
    this.actionSteps = [];
    this.currentActionIndex = 0;
    this.objectivesAchieved = false;
  },
  approveAction() {
    // Execute the current action and move to the next recommended action
    this.executeAction(this.actionSteps[this.currentActionIndex]);
    this.nextRecommendedAction();
  },
  nextRecommendedAction() {
      if (this.currentActionIndex < this.actionSteps.length - 1) {
        this.currentActionIndex++;
      } else {
        this.currentActionIndex = 0;
      }
    },
  executeContinuousMode() {
    this.continuousMode = !this.continuousMode; // Toggle continuous mode

    if (this.continuousMode) {
      for (const step of this.actionSteps) {
        this.executeAction(step);
      }

      this.objectivesAchieved = true;
    }
  },
  executeAction(action) {
    // Implement the logic to execute the action, such as interacting with the opened web page
    console.log(`Executing action: ${action}`);
  },
  saveQuery() {
      if (this.editingQueryIndex === -1) {
        this.savedQueries.push(this.queryPrompt);
      } else {
        this.savedQueries[this.editingQueryIndex] = this.queryPrompt;
        this.editingQueryIndex = -1;
      }
      localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
    },
    updateQuery() {
      if (this.editingQueryIndex !== -1) {
        this.savedQueries[this.editingQueryIndex] = this.queryPrompt;
        this.editingQueryIndex = -1;
        localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
      }
    },
    editSavedQuery(index) {
      this.queryPrompt = this.savedQueries[index];
      this.editingQueryIndex = index;
      if (this.lastSavedUrl) {
        window.open(this.lastSavedUrl, "_blank");
      }
      this.dialogueHistory.push(`<strong>User:</strong> ${this.queryPrompt}`);
    },
    deleteSavedQuery(index) {
      this.savedQueries.splice(index, 1);
      localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
    },
  },
};
</script>



<style>
.ace_cursor {
  border-right: 0.15em solid orange;
  animation: blink-caret 0.5s step-end infinite;
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from,
  to {
    border-color: transparent;
  }
  50% {
    border-color: orange;
  }
}
.ace_line {
  white-space: nowrap;
  margin: 0 auto;
  letter-spacing: 0.15em;
  animation: typing 0.0001s steps(200, end);
}

/* The typing effect */
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 5px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
@media only screen and (max-width: 900px) {
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
}
.inputarea {
  width: 100%;
  height: 100%;
  overflow: auto;
  scroll-margin-bottom: 10px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 16px;
  resize: none;
}

#codeEditor {
    width: 100%;
    height: 400px;
}
  #outputIframe {
    width: 100%;
    height: 400px;
    border: 1px solid #ccc;
  }
  
  #dialogueResults {
    padding: 10px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
    max-height: 200px;
    overflow-y: auto;
  }
  #savedProjects {
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  max-height: 200px;
  overflow-y: auto;
}
</style>
